import React, { useState } from "react";
import Slider from "react-slick";
import { Outlet, useLocation } from "react-router-dom";

import { Box } from "@mui/material";

import { Header, Footer } from "../components";
import { ModalLogin } from "../components/ModalLogin";

const LayoutLadingPage = () => {
  const [open, setOpen] = useState(false);
  const handleLogin = () => setOpen((prev) => !prev);

  return (
    <Box sx={{ width: "100%", overflowX: "hidden", boxSizing: "border-box" }}>
      <Header handleLogin={handleLogin} />
      <Box sx={{ width: "100%" }}>
        <Box sx={{ width: "100%", maxWidth: 1600, margin: "0 auto", paddingLeft: "24px", paddingRight: "24px", boxSizing: "border-box" }}>
          <Outlet context={{ handleLogin }} />
        </Box>
      </Box>
      <Footer />
      <ModalLogin open={open} onClose={handleLogin} />
    </Box>
  );
};

export default LayoutLadingPage;
